import { VolumeOffIcon } from './VolumeOffIcon';

/**
 * author: Google
 * id 74834C94-6AE1-493B-A9FB-4EE2A8FD989C
 * name volume-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volume-off.svg
 * tags
 * - Audio 
 * - Home Automation 
 * - Cellphone / Phone 
 */
export const AudioOffIcon = VolumeOffIcon;
export default AudioOffIcon